var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1443",
    "data-name": "Path 1443",
    d: "M14,12.767,11.094,9.862a6.029,6.029,0,0,0,1.233-3.7A6.126,6.126,0,0,0,6.164,0,6.126,6.126,0,0,0,0,6.164a6.126,6.126,0,0,0,6.164,6.164,6.029,6.029,0,0,0,3.7-1.233L12.767,14ZM1.761,6.164a4.36,4.36,0,0,1,4.4-4.4,4.36,4.36,0,0,1,4.4,4.4,4.36,4.36,0,0,1-4.4,4.4A4.36,4.36,0,0,1,1.761,6.164Z",
    fill: "#1a1824",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search_icon.2c8be9df1018874efe4b6a1a49ad8a5a.svg";
export { ForwardRef as ReactComponent };